module.exports = __webpack_public_path__ + "img/layer2_00001.a6d68495.png";